'use client';

import { useEffect, useRef } from 'react';

import { useLocalStorage } from '@nf/utils-common/hooks';
import { uiService } from '@/services/ui.service';

export const SingleBetBookingTipContainer = () => {
	const [isBookingTipViewed, setIsBookingTipViewed] = useLocalStorage('persist:is-bet-booking-tip2-viewed', false);
	const isBookingTipViewedRef = useRef(isBookingTipViewed);

	useEffect(() => {
		!isBookingTipViewed && setIsBookingTipViewed(true);
		!isBookingTipViewedRef.current && uiService.displayBookingFeatureTip();
	}, [isBookingTipViewed]);

	return null;
};